import {useMemo} from 'react';

const UseCitizenAttaches = (citizen, attaches, aggressors) => {
    return useMemo(() => {
        const ids = new Set();

        if (citizen?.victimPicture) ids.add(citizen.victimPicture);
        citizen?.addresses?.forEach(a => { if (a?.attachId) ids.add(a.attachId) });
        citizen?.vehicles?.forEach(v => { if (v?.attachId) ids.add(v.attachId) });
        aggressors?.forEach(ag => {
            if (ag?.attachId) ids.add(ag.attachId);
            ag?.addresses?.forEach(a => { if (a?.attachId) ids.add(a.attachId) });
            ag?.vehicles?.forEach(v => { if (v?.attachId) ids.add(v.attachId) });
        });

        return attaches?.filter(a => !ids.has(a.attachId)) ?? [];
    }, [citizen, attaches, aggressors]);
};

export default UseCitizenAttaches;